/**
 * Defines a method for notifying Stateful object watchers
 */
define([
    "dojo/_base/declare"
], function (declare) {

    /**
     * @class StatefulExtension
     */
    return declare([], {
        /**
         * Notifies any watchers of a property change.  This differs from the inherited _changeAttrValue
         * method in that it does not store the value, nor does it call get to obtain the oldValue.
         * Hence it is appropriated to use when the value has already been changed.
         *
         * It also supports lazy newValue evaluation.  If the "newValue" parameter is a function it will be
         *  evaluated to obtain the actual new value but only if there is an applicable watcher.
         *
         * @param name
         * @param oldValue
         * @param newValue
         * @param coaleseDelay if defined the notification will be delayed with additional notification calls for
         *                     the same property prior to the delay expiration being coalesced into a single notification.
         */
        notifyStateWatchers: function(name, oldValue, newValue, coalesceDelay) {
            if (this._watchCallbacks){
                var that = this;
                if (coalesceDelay !== undefined) {
                    if (!this._pendingWatchNotifications) {
                        this._pendingWatchNotifications = {};
                    }
                    var pending = this._pendingWatchNotifications[name];
                    if (pending) {
                        pending.newValue = newValue;
                    } else {
                        this._pendingWatchNotifications[name] = {oldValue: oldValue, newValue: newValue};
                        setTimeout(function () {
                            var pending = that._pendingWatchNotifications[name];
                            delete that._pendingWatchNotifications[name];
                            that.notifyStateWatchers(name, pending.oldValue, pending.newValue);
                        }, coalesceDelay);
                    }
                    return;
                }

                if (typeof newValue === "function") {
                    if (this._watchCallbacks['_' + name] || this._watchCallbacks['*']) {
                        newValue = newValue();
                    } else {
                        return;
                    }
                }
                this._watchCallbacks(name, oldValue, newValue);
            }
        },

        /**
         * Adds a watch callback in front of any callbacks previously added.
         * @param name
         * @param callback
         */
        preferredWatch: function(name, callback) {
            var handle = this.watch(name, callback);
            if (typeof name === "string") {
                var callbacks = this._watchCallbacks['_' + name];
                var len = callbacks.length;
                if (len > 1) {
                    var lastCallback = callbacks[len-1];
                    for (i = len-1; i >= 1; i--) {
                        callbacks[i] = callbacks[i - 1];
                    }
                    callbacks[0] = lastCallback;
                }
            }
            return handle;
        }
    });
});